import React from "react";

import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";
import { ILocalCancellationPolicy } from "~/types/local-types";

import { ReadMoreText } from "../../utils/ReadMoreToggle";

interface CancellationProps {
  cancellationPolicy: ILocalCancellationPolicy;
}

const Cancellation: React.FC<CancellationProps> = ({ cancellationPolicy }) => {
  const compiledText = (
    <>
      {cancellationPolicy.text}{" "}
      <a
        href={cancellationPolicy.link}
        rel="noopener noreferrer"
        target="_blank"
        className="tw-underline"
        aria-label={`Learn more about the cancellation policy`}
        data-testing-id="cancellationPolicyLearnMoreLink"
      >
        <FormattedMessage
          id="listing.listing_main.learn_more"
          defaultMessage="Learn more"
        />
      </a>
    </>
  );
  return (
    <div className="tw-py-40">
      <Text
        element="h2"
        typeface="headline-2-m"
        data-testing-id="cancellationPolicySectionTitle"
      >
        <FormattedMessage
          id="listing.listing_main.cancellation_policy_header"
          defaultMessage="Cancellation Policy"
        />
      </Text>
      <div>
        <div className="tw-pb-8">
          <Text
            typeface="headline-1-m"
            element="h3"
            className="tw-py-8"
            data-testing-id="cancellationPolicyLabel"
          >
            {cancellationPolicy.title}
          </Text>
          <ReadMoreText
            text={compiledText}
            readMoreButtonDataTestingId="cancellationPolicySectionReadMoreButton"
            hideButtonDataTestingId="cancellationPolicySectionHideButton"
          />
        </div>
        {cancellationPolicy.gracePeriodApplies && (
          <Text className="tw-text-gray-600" typeface="body-1">
            <FormattedMessage
              id="listing.listing_main.grace_period_text"
              defaultMessage="All Bookings are subject to Peerspace’s Grace Period policy which provides a full refund for Bookings cancelled within 24 hours from receipt of a Booking Confirmation but no later than 48 hours prior to the Event start time."
            />
          </Text>
        )}
      </div>
    </div>
  );
};

export default Cancellation;
